import React, { HTMLProps, useState } from 'react';
import styles from '../styles/passwordInput.module.scss';
import { ReactComponent as Eye } from '@ui-kit/icons/open-eye.svg';
import { ReactComponent as EyeCrossed } from '@ui-kit/icons/closed-eye.svg';

const PasswordInput = React.forwardRef(
  (
    props: HTMLProps<HTMLInputElement>,
    ref: React.LegacyRef<HTMLInputElement> | undefined
  ) => {
    const [visible, setVisible] = useState(false);
    return (
      <div className={styles.passwordInput}>
        <input type={visible ? 'text' : 'password'} {...props} ref={ref} />
        <div className={styles.icon} onClick={() => setVisible((v) => !v)}>
          {visible ? <Eye /> : <EyeCrossed />}
        </div>
      </div>
    );
  }
);

export default PasswordInput;
